/* NESTORA - conversion product page.

   Vanilla, no libraries, scoped to this section.

   Money is never formatted here. Every price string was rendered by Liquid
   into the variant map; this only swaps them in. The stock pill reads real
   Shopify inventory out of that same map - there is no invented counter.

   Add to cart posts to /cart/add.js and hands the response to Dawn's own
   <cart-notification>, so the theme's existing AJAX cart keeps working.
*/
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ready === '1') return;

    var map;
    try {
      map = JSON.parse(root.querySelector('[data-nstpp-map]').textContent);
    } catch (e) {
      return;
    }

    root.dataset.ready = '1';

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var slides = q('[data-pp-slides]');
    var dots = qa('[data-pp-dot]');
    var priceEl = q('[data-pp-price]');
    var wasEl = q('[data-pp-was]');
    var saveEl = q('[data-pp-save]');
    var stockEl = q('[data-pp-stock]');
    var stockText = q('[data-pp-stock-text]');
    var qtyEl = q('[data-pp-qty]');
    var qtyInput = q('[data-pp-qtyinput]');
    var idInput = q('[data-pp-id]');
    var form = q('[data-pp-form]');
    var addBtn = q('[data-pp-add]');
    var addPrice = q('[data-pp-add-price]');
    var addLabel = q('[data-pp-add-label]');
    var sticky = q('[data-pp-sticky]');
    var stickyAdd = q('[data-pp-sticky-add]');
    var stickyPrice = q('[data-pp-sticky-price]');
    var stickyLabel = q('[data-pp-sticky-label]');

    var threshold = parseInt(root.getAttribute('data-pp-threshold'), 10) || 25;
    var showStock = root.getAttribute('data-pp-showstock') === 'true';
    var addLabelText = addLabel ? addLabel.textContent.trim() : 'ADD TO CART';
    var qty = 1;

    function variantId() {
      var checked = root.querySelector('[data-pp-variant]:checked');
      if (checked) return String(checked.value);
      return idInput ? String(idInput.value) : '';
    }

    /* ---- gallery -------------------------------------------------------- */
    function markDot(i) {
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }

    if (slides && dots.length) {
      var ticking = false;
      slides.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          markDot(Math.round(slides.scrollLeft / slides.clientWidth));
        });
      }, { passive: true });

      dots.forEach(function (d, n) {
        d.addEventListener('click', function () {
          slides.scrollTo({ left: slides.clientWidth * n, behavior: 'smooth' });
        });
      });
    }

    function showMedia(i) {
      if (!slides || i < 0) return;
      slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
      markDot(i);
    }

    /* ---- render --------------------------------------------------------- */
    function render() {
      var d = map[variantId()];
      if (!d) return;

      if (priceEl) priceEl.textContent = d.price;
      if (addPrice) addPrice.textContent = d.price;
      if (stickyPrice) stickyPrice.textContent = d.price;

      if (wasEl) {
        wasEl.textContent = d.was || '';
        wasEl.hidden = !d.was;
      }

      if (saveEl) {
        if (d.save > 0) {
          saveEl.textContent = 'Save ' + d.save + '%';
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }

      /* Real inventory only. -1 means the product does not track stock, so
         there is nothing truthful to say and the pill stays hidden. */
      if (stockEl) {
        var show = showStock && d.inventory > 0 && d.inventory <= threshold;
        if (show && stockText) {
          stockText.textContent = 'Only ' + d.inventory + ' left in stock';
        }
        stockEl.hidden = !show;
      }

      var off = d.available === false;
      if (addBtn) addBtn.disabled = off;
      if (stickyAdd) stickyAdd.disabled = off;
      if (addLabel) addLabel.textContent = off ? 'Sold out' : addLabelText;
      if (stickyLabel) stickyLabel.textContent = off ? 'Sold out' : addLabelText;

      if (idInput) idInput.value = variantId();
      if (d.media >= 0) showMedia(d.media);
    }

    qa('[data-pp-variant]').forEach(function (input) {
      input.addEventListener('change', render);
    });

    /* ---- quantity ------------------------------------------------------- */
    function setQty(n) {
      qty = Math.max(1, n);
      if (qtyEl) qtyEl.textContent = String(qty);
      if (qtyInput) qtyInput.value = String(qty);
      qa('[data-pp-deal]').forEach(function (b) {
        b.classList.toggle('is-on', parseInt(b.getAttribute('data-pp-deal'), 10) === qty);
      });
    }

    var minus = q('[data-pp-minus]');
    var plus = q('[data-pp-plus]');
    if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

    qa('[data-pp-deal]').forEach(function (b) {
      b.addEventListener('click', function () {
        setQty(parseInt(b.getAttribute('data-pp-deal'), 10) || 1);
      });
    });

    /* ---- coupon --------------------------------------------------------- */
    var copy = q('[data-pp-copy]');
    var code = q('[data-pp-code]');
    if (copy && code) {
      copy.addEventListener('click', function () {
        var text = code.textContent.trim();
        var done = function () {
          var old = copy.textContent;
          copy.textContent = 'Copied';
          setTimeout(function () { copy.textContent = old; }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, done);
        } else {
          done();
        }
      });
    }

    /* ---- cart -----------------------------------------------------------
       Dawn's notification renders specific sections and knows their ids, so
       ASK IT which ones to fetch. Hard-coding "cart-notification" returns a
       payload it cannot read, renderContents throws, and every add silently
       falls through to a full page load of /cart - which is exactly what
       happened the first time round.
       -------------------------------------------------------------------- */
    function cartUI() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    function addToCart(items, button) {
      var ui = cartUI();
      var body = { items: items };

      if (ui && typeof ui.getSectionsToRender === 'function') {
        try {
          body.sections = ui.getSectionsToRender().map(function (s) { return s.id; }).join(',');
          body.sections_url = window.location.pathname;
        } catch (e) {
          /* fall through without sections - the add still happens */
        }
      }

      if (button) button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state && state.status) throw new Error(state.description || 'cart error');
          if (ui && typeof ui.renderContents === 'function' && state.sections) {
            ui.renderContents(state);
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .then(function () {
          if (button) button.disabled = false;
        });
    }

    function currentItems() {
      return [{ id: variantId(), quantity: qty }];
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addToCart(currentItems(), addBtn);
      });
    }

    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        addToCart(currentItems(), stickyAdd);
      });
    }

    var bundleBtn = q('[data-pp-bundle]');
    if (bundleBtn) {
      bundleBtn.addEventListener('click', function () {
        var ids = (bundleBtn.getAttribute('data-pp-bundle-ids') || '').split(',');
        var items = [];
        ids.forEach(function (id) {
          var trimmed = id.trim();
          if (trimmed) items.push({ id: trimmed, quantity: 1 });
        });
        if (items.length) addToCart(items, bundleBtn);
      });
    }

    /* ---- sticky bar ----------------------------------------------------- */
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var on = !entry.isIntersecting;
            sticky.classList.toggle('is-on', on);
            sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          });
        },
        { rootMargin: '0px 0px -10% 0px' }
      ).observe(form);
    }

    setQty(1);
    render();
  }

  function boot() {
    document.querySelectorAll('[data-nstpp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-nstpp]').forEach(function (el) { el.dataset.ready = ''; });
    boot();
  });
})();
